<template>
  <div class="gallery-seq-list">
    <div
      v-for="seq in seqList"
      :key="seq.id"
      class="gallery-seq-item"
      :class="{ 'gallery-seq-item--selected': isSelected(seq.id) }"
      @click="toggleSelection(seq)"
    >
      <SequenceCard
        :sequence="seq"
        :selected="isSelected(seq.id)"
        :shouldShowSelector="true"
        @update:selected="toggleSelection(seq)"
        @delete="$emit('sequence-deleted', seq)"
        @edit-description="$emit('sequence-edit', $event)"
        @download="$emit('sequence-download', seq)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import SequenceCard from './SequenceCard.vue';

const props = defineProps({
  seqList: {
    type: Array,
    default: () => []
  },
  modelValue: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update:modelValue', 'sequence-deleted', 'sequence-edit', 'sequence-download']);

const isSelected = (seqId) => {
  return props.modelValue.some(item => item.id === seqId);
};

const toggleSelection = (seq) => {
  if (isSelected(seq.id)) {
    emit('update:modelValue', props.modelValue.filter(item => item.id !== seq.id));
  } else {
    emit('update:modelValue', [...props.modelValue, seq]);
  }
};
</script>

<style lang="scss" scoped>
.gallery-seq-list {
  display: flex;
  gap: 12px;
  padding: 16px;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: auto;
}

.gallery-seq-item {
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
    transform: scale(1.02);
  }

  &--selected {
    box-shadow: 0 0 0 2px var(--color-primary);
  }
}
</style>
